export default __webpack_public_path__ + "img_220720_PWD_lockup_Squid_Aurora_CMYK.svg";